import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Select from '../../../../components/Select'
import BannerImage from '../../../../components/BannerImage'
import TeamCard from './TeamCard'

const TeamSelectLabel = ({ team }: { team: wowaudit.TeamReference }) => (
  <span className='flex min-w-0 items-center gap-2 text-left'>
    <BannerImage
      faction={team.ownerReference.faction}
      fileName={team.ownerReference.bannerFilename}
      size='small'
    />
    <span className='min-w-0'>
      <span className='block truncate font-medium'>
        {team.ownerReference.name}
      </span>
      <span className='block truncate text-xs text-muted-foreground'>
        {team.name}
      </span>
    </span>
  </span>
)

const PersonalizedTeams = ({ teams }: { teams: wowaudit.TeamReference[] }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const options = teams.map((team) => ({
    value: team.path,
    label: <TeamSelectLabel team={team} />,
    sortLabel: `${team.ownerReference.name} ${team.name}`,
  }))

  return (
    <section className='flex flex-col gap-2'>
      <div className='flex items-end justify-between gap-4'>
        <h4 className='text-base font-medium text-foreground mb-0'>
          {t('homepage.your-teams-heading')}
        </h4>
        {teams.length > 3 ? (
          <Select
            value={undefined}
            setValue={(path) => path && navigate(path)}
            options={options}
            placeholder={t('homepage.all-teams')}
            optionWidth='fit'
            className='h-6 w-fit bg-transparent hover:bg-transparent border-none font-normal'
          />
        ) : null}
      </div>

      <div className='grid grid-cols-1 gap-2 sm:grid-cols-3'>
        {teams.slice(0, 3).map((team) => (
          <TeamCard key={team.id} team={team} />
        ))}
      </div>
    </section>
  )
}

export default PersonalizedTeams
